// ============================================
// COMPONENT: PlantModal - FINAL CORREGIDO
// ============================================
// Archivo: src/components/modals/PlantModal.jsx

import React, { useState, useEffect } from 'react';
import { Modal, Input, Button } from '../common';

const PlantModal = ({ 
  show, 
  plant = null,
  onClose, 
  onSubmit 
}) => {
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    location: '',
    code: '',
    manager: '',
    schedule: '08:00-20:00',
    contact: '',
    lines: 4
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const isEdit = !!plant;

  useEffect(() => {
    // Solo ejecutar cuando el modal está visible
    if (!show) return;
    
    console.log('🔍 PlantModal - useEffect triggered');
    console.log('🔍 Plant data received:', plant);
    console.log('🔍 Show:', show);
    
    if (plant) {
      console.log('✅ Loading plant data into form');
      setFormData({
        id: plant.id || '',
        code: plant.code || '',
        name: plant.name || '',
        location: plant.location || '',
        manager: plant.manager || '',
        schedule: plant.schedule || '08:00-20:00',
        contact: plant.contact || '',
        lines: plant.lines || 4
      });
    } else {
      console.log('➕ Creating new plant');
      setFormData({
        id: '',
        code: '',
        name: '',
        location: '',
        manager: '',
        schedule: '08:00-20:00',
        contact: '',
        lines: 4
      });
    }
    setErrors({});
  }, [plant, show]);

  const validate = () => {
    const newErrors = {};

    // Solo validar código si es creación (no edición)
    if (!isEdit && !formData.code.trim()) {
      newErrors.code = 'El código es obligatorio para plantas nuevas';
    }

    if (!formData.name.trim()) {
      newErrors.name = 'El nombre es obligatorio';
    }

    if (formData.lines < 1 || formData.lines > 10) {
      newErrors.lines = 'El número de líneas debe estar entre 1 y 10';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    setLoading(true);

    try {
      // Mapear campos de inglés a español para el backend
      const submitData = {
        codigo: formData.code,
        nombre: formData.name,
        direccion: formData.location,
        jefe: formData.manager,
        contacto: formData.contact,
        horario: formData.schedule,  // ✅ español
        lineas: formData.lines        // ✅ español
      };
      
      console.log('📤 Enviando al backend:', submitData);
      
      // ✅ FIX: usar formData.id para evitar null.id
      const plantId = formData.id || plant?.id;
      await onSubmit(submitData, plantId);
      onClose();
    } catch (error) {
      console.error('Error al guardar planta:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={isEdit ? 'Editar Planta' : 'Nueva Planta'}
      size="md"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Código de Planta"
          value={formData.code}
          onChange={(e) => setFormData({ ...formData, code: e.target.value.toUpperCase() })}
          placeholder="Ej: PRT-1"
          required
          error={errors.code}
        />

        <Input
          label="Nombre de Planta"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder="Ej: PRT Arica"
          required
          error={errors.name}
        />

        <Input
          label="Ubicación"
          value={formData.location}
          onChange={(e) => setFormData({ ...formData, location: e.target.value })}
          placeholder="Ej: Arica, Chile"
        />

        <Input
          label="Jefe de Planta"
          value={formData.manager}
          onChange={(e) => setFormData({ ...formData, manager: e.target.value })}
          placeholder="Ej: Juan Pérez"
        />

        <Input
          label="Teléfono de Emergencia"
          value={formData.contact}
          onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
          placeholder="Ej: +56912345678"
        />

        <Input
          label="Horario de Operación"
          value={formData.schedule}
          onChange={(e) => setFormData({ ...formData, schedule: e.target.value })}
          placeholder="Ej: 08:00-20:00"
        />

        <Input
          label="Número de Líneas"
          type="number"
          value={formData.lines}
          onChange={(e) => setFormData({ ...formData, lines: parseInt(e.target.value) || 1 })}
          placeholder="Ej: 4"
          required
          error={errors.lines}
          min={1}
          max={10}
        />

        <div className="flex gap-3 pt-4">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            fullWidth
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? 'Guardando...' : isEdit ? 'Actualizar' : 'Crear Planta'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default PlantModal;